import React, { useEffect, useState, useContext } from "react";
import "./Warranty2.css";

import snowIcon from "../../../../assets/icons/snow.png";
import mudIcon from "../../../../assets/icons/mud.png";
import rockIcon from "../../../../assets/icons/rock.png";
import sandIcon from "../../../../assets/icons/sand.png";
import waterIcon from "../../../../assets/icons/water.png";
import autoIcon from "../../../../assets/icons/auto.png";

import carImage from "../../../../assets/images/mhero2/warrantyCar.png";

import { LanguageContext } from "../../../../context/LanguageContext";
import { getPageContent } from "../../../../api/publicContent.api";

const MODE_ICONS = {
  mode_snow: snowIcon,
  mode_mud: mudIcon,
  mode_rock: rockIcon,
  mode_sand: sandIcon,
  mode_water: waterIcon,
  mode_auto: autoIcon,
};

const MODE_KEYS = [
  "mode_snow",
  "mode_mud",
  "mode_rock",
  "mode_sand",
  "mode_water",
  "mode_auto",
];

const Warranty2 = () => {
  const { currentLang } = useContext(LanguageContext);

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadContent = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await getPageContent("mhero2", currentLang);
        setData(response.sections?.warranty);
      } catch (err) {
        console.error("CMS load error:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    loadContent();
  }, [currentLang]);

  if (loading) return null;
  if (error || !data) return null;

  return (
    <section className="warranty2">
      {/* TOP MODES */}
      <div className="warranty2-modes">
        <p className="warranty2-title">{data.title}</p>

        <div className="warranty2-modes-row">
          {MODE_KEYS.map((key, i) => (
            <React.Fragment key={key}>
              <div className="warranty2-mode">
                <img src={MODE_ICONS[key]} alt={data[key]} />
                <span>{data[key]}</span>
              </div>

              {i !== MODE_KEYS.length - 1 && (
                <span className="warranty2-divider" />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>

      {/* ARC + CONTENT */}
      <div className="warranty2-arc">

        {/* 🔥 CODE BADGE */}
        <div className="warranty2-badge">
          <p className="badge-label">{data.warranty_label}</p>
          <p className="badge-years">{data.warranty_years}</p>
          <p className="badge-sub">{data.warranty_sub}</p>
        </div>

        <img
          src={carImage}
          alt="Car"
          className="warranty2-car"
        />
      </div>
    </section>
  );
};

export default Warranty2;